module.exports = __webpack_public_path__ + "static/media/Genital Warts.81fbe638.webp";